<script>
import ProjectSingle from '../projects/ProjectSingle.vue';

export default {
	name: 'HomeShowcase',
	components: { ProjectSingle },
	props: {
		// 区块标题
		title: { type: String, required: true },
		// 项目数据数组（自动只取前 3 条）
		items: { type: Array, required: true },
		// 卡片点击跳转前缀，默认 /projects
		basePath: { type: String, default: '/projects' },
		// “更多”按钮跳转目标
		moreLink: { type: String, required: true },
		// “更多”按钮文案
		moreText: { type: String, default: '查看更多' },
	},
	computed: {
		// 只展示一行三个
		previewItems() {
			return this.items.slice(0, 3);
		},
	},
};
</script>

<template>
	<section class="pt-10 sm:pt-14">
		<!-- 区块标题 -->
		<div class="text-center">
			<p
				class="font-general-semibold text-2xl sm:text-5xl font-semibold mb-2 text-ternary-dark dark:text-ternary-light"
			>
				{{ title }}
			</p>
		</div>

		<!-- 项目卡片网格（一行三个） -->
		<div
			class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 mt-6 sm:gap-10"
		>
			<ProjectSingle
				v-for="item in previewItems"
				:key="item.id"
				:project="item"
				:base-path="basePath"
			/>
		</div>

		<!-- 更多按钮 -->
		<div class="mt-8 sm:mt-12 flex justify-center">
			<router-link
				:to="moreLink"
				class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-indigo-500 hover:bg-indigo-600 focus:ring-1 focus:ring-indigo-900 text-white text-lg sm:text-xl duration-300"
				:aria-label="moreText"
			>
				{{ moreText }}
			</router-link>
		</div>
	</section>
</template>

<style scoped></style>
